import { StyledLogo } from '@/components/styles'
import { ActiveLink } from '@/components'
import { useTranslation } from 'react-i18next'
import { localizePath } from '@/lib/locales'

export default function Logo({ theme = 'default', ...props }) {
  const { i18n } = useTranslation('global')
  const homeAs = localizePath('/', i18n.language)
  return (
    <ActiveLink href="/" as={homeAs}>
      <StyledLogo theme={theme}>
        <img src="/images/logo.jpeg" alt="Sante" height={54} width={237}/>
      </StyledLogo>
    </ActiveLink>
  )
}
